import React from 'react'
import { useHistory } from 'react-router-dom'
import Table from 'src/components/Table/Table'
import { Asset } from 'src/types'

const TableAssets = ({ assets }: { assets: Asset[] }) => {
  const history = useHistory()
  const handleSelect = row => history.push('/assets/' + (row.slug || row.activeID))
  return (
    <Table
      handleSelect={handleSelect}
      name={'assets'}
      data={assets}
      columns={[
        { name: 'prinexId' },
        { name: 'address' }
      ]}
    />
  )
}

export default TableAssets
